// 函数去抖
// refers: https://www.cnblogs.com/fsjohnhuang/p/4147810.html
/**
 * 空闲控制 返回函数连续调用时，空闲时间必须大于或等于 idle，action 才会执行
 * @param idle {number}    空闲时间，单位毫秒
 * @param action {function}  请求关联函数，实际应用需要调用的函数
 * @returns {Function} 返回客户调用函数
 */
export function debounce (idle, action) {
  let last
  return function () {
    let ctx = this
    let args = arguments
    clearTimeout(last)
    last = setTimeout(function () {
      action.apply(ctx, args)
    }, idle)
  }
}

// 函数节流
// refers: https://www.cnblogs.com/fsjohnhuang/p/4147810.html
/**
 * 频率控制 返回函数连续调用时，action 执行频率限定为 次 / delay
 * @param delay {number}    延迟时间，单位毫秒
 * @param action {function}  请求关联函数，实际应用需要调用的函数
 * @returns {Function} 返回客户调用函数
 */
export function throttle (delay, action) {
  let last = 0
  return function () {
    let curr = +new Date()
    if (curr - last > delay) {
      action.apply(this, arguments)
      last = curr
    }
  }
}

export default {
  debounce,
  throttle
}



// WEBPACK FOOTER //
// ./src/utils/rate-limit.js